import React, { useEffect } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { useModels } from './ModelStore';
import { useBrands } from '../Brands/BrandStore';
import { useForm } from 'antd/es/form/Form';

function Edit() {
    let { updateModel, ed } = useModels()
    let { getBrands, brands } = useBrands()
    let [form] = useForm();
    useEffect(() => {
        getBrands()
    }, [])
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    return (
        <Form form={form} layout="vertical" onFinish={updateModel} encType="multipart/form-data">
            <Form.Item name={'id'} hidden>
                <Input />
            </Form.Item>
            <Form.Item label="O'zbekcha nomi" name="nameuz" rules={[{ required: true, message: 'Please input your name!' }]}>
                <Input />
            </Form.Item>
            <Form.Item label="Ruscha nomi" name="nameru" rules={[{ required: true, message: 'Please input your description!' }]}>
                <Input />
            </Form.Item>
            <Form.Item label="Brand" name="brand_id">
                <Select options={brands.map(brand => ({ label: brand.nameuz, value: brand.id }))} showSearch optionFilterProp="label" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Taxrirlash</Button>
            </Form.Item>
        </Form>
    );
}

export default Edit;